import React from "react";
import { Link } from "react-router-dom";

const mainButton = ({ link, name }) => {
  return (
    <>
      {link !== "#" && (
        <Link to={link}>
          <div className="mainButton-container">
            <div className="title">{name}</div>
          </div>
        </Link>
      )}
      {link === "#" && (
        <>
          <div className="mainButton-container">
            <div className="title">{name}</div>
          </div>
        </>
      )}
    </>
  );
};

export default mainButton;
